export default __webpack_public_path__ + "static/media/needs-attention.92077169.svg";